const $progressBar = $('.page-loading .progress-bar');
let $header;
let $headerNav;
let mobileGa;
let isFirstTime = true;
let sectionPos = [];
let sectionPage = [];
let footerPos;
const $doc = $(document);
const $win = $(window);
const $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');
let winW, winH;
let nowPos;

// 快取 DOM 元素，避免在 scroll 時不斷重新查詢
let $navLi;
let $headerNavContainer;
let currentActiveIdx = -1; // 記錄當前 active 的選單
let lastGaSectionIdx = -1; // 記錄最後一次發送 GA 的區塊
let isTopGaFired = false;  // 記錄首頁 GA 是否已發送

/*==================================================*\
  Main Function
\*==================================================*/
const { createApp, ref, nextTick } = Vue;

createApp({
  setup() {
    const sections = ref([]);

    fetch('js/data.json')
      .then(res => res.json())
      .then(data => {
        sections.value = data.sections;
        nextTick(() => {
          const $progressBar = $('.progress-bar');
          listenImagesLoading(
            $('#app img'), // 可依實際區塊調整
            mainFunc,
            function(per, instance) {
              $progressBar.css({ width: per + '%' });
            }
          );
        });
      });

    return {
      sections
    };
  }
}).mount('#app');

function mainFunc() {
  $header = $('.page-header');
  $headerNav = $('.header-nav ul');
  $navLi = $('.header-nav li');
  $headerNavContainer = $('.header-nav');

  windowEvents();

  $('._lb').each(function (i, v) {
    $(v).lightbox({
      filesDefaultExtension: '.' + ($(v).data('lbext') || 'html'),
      callback: function () {
        if (typeof lbOnload !== 'undefined') lbOnload();
      }
    });
  });

  $('._scrollto').on('click', function () {
    const target = $(this).data("scrollto");
    scrollto(target);
  });

  $('.header-gotop').on('click', function () {
    $('html, body').stop().animate({
      scrollTop: $('.kv').offset().top
    }, 500);
  });

  transitionThenRemove({
    dom: $(".page-loading"),
    duration: 300,
    callback: () => {
      console.log("%cBuild Completed!", 'color: green');
    }
  });
}

function windowEvents() {
  // Resize 防抖 (Debounce)：縮放結束後再計算，避免縮放過程中瘋狂重算
  let resizeTimer;
  $win.on("resize", function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(_resize, 200);
  }).resize();

  // Scroll 節流 (Throttle via requestAnimationFrame)：讓滾動動畫平滑且不卡頓
  let isScrollTicking = false;
  $win.on("scroll", function() {
    if (!isScrollTicking) {
      window.requestAnimationFrame(function() {
        _scroll();
        isScrollTicking = false;
      });
      isScrollTicking = true;
    }
  }).scroll();
}

function _resize() {
  getSize();
  getSectionPos();
  footerPos = $('footer').offset().top;
}

function getSize() {
  winW = $win.width();
  winH = $win.height();
}

function getSectionPos() {
  sectionPos = [];
  sectionPage = [];

  $('.sec').each((idx, el) => {
    sectionPos.push(Math.floor($(el).offset().top));
    sectionPage.push($(el).attr('data-page'));
  });
}

function _scroll() {
  getPos();
  
  const winTop = $win.scrollTop();
  $header.css('opacity', winTop >= 250 ? '1' : '0');

  // GA 優化：首頁 (index) 只觸發一次，除非重新回到頂部
  if (winTop === 0 && !isTopGaFired) {
    gtag('event', 'pageName', { event_label: 'index' });
    isTopGaFired = true;
  } else if (winTop > 0) {
    isTopGaFired = false; 
  }

  setNavigationHint();
}

function getPos() {
  nowPos = {
    x: $doc.scrollLeft(),
    y: $doc.scrollTop(),
    top: $doc.scrollTop() + 1
  };
}

function setNavigationHint() {
  const NAV_HINT_CLASS = 'active';
  let matchedIdx = -1;

  // 找出目前畫面所在的區塊
  sectionPos.forEach((val, idx) => {
    if (nowPos.top >= val && nowPos.top < footerPos) {
      matchedIdx = idx;
    }
  });

  // 如果滾動到頁首或頁尾，清除 active
  if ((matchedIdx === 0 && nowPos.top < sectionPos[0]) || nowPos.top >= footerPos) {
    if (currentActiveIdx !== -1) {
      $navLi.removeClass(NAV_HINT_CLASS);
      currentActiveIdx = -1;
    }
    return;
  }

  // 避免重複執行 DOM 操作，只有當所在的區塊改變時才更新 Class 和發送 GA
  if (matchedIdx !== currentActiveIdx && matchedIdx !== -1) {
    $navLi.removeClass(NAV_HINT_CLASS);
    $navLi.eq(matchedIdx).addClass(NAV_HINT_CLASS);
    currentActiveIdx = matchedIdx;

    // GA 觸發優化：進入新區塊時發送一次
    if (lastGaSectionIdx !== matchedIdx) {
      const label = winW > 768 ? sectionPage[matchedIdx] : 'm_' + sectionPage[matchedIdx];
      gtag('event', 'pageName', { event_label: label });
      lastGaSectionIdx = matchedIdx;
    }

    // 行動版選單滾動置中
    if (winW <= 768) {
      const posNav = $navLi.eq(matchedIdx).offset().left - $headerNavContainer.offset().left + $headerNavContainer.scrollLeft() - $navLi.eq(matchedIdx).width();
      $headerNavContainer.scrollLeft(posNav);
    }
  }
}

function scrollto(anchor) {
  $body.stop().animate({
    scrollTop: $('#' + anchor).offset().top
  }, 500);
}

function navScrollLeft() {
  const posNav = $('.header-nav .active').offset().left - ($(window).width() * 0.15);
  $headerNavContainer.scrollLeft(posNav);
}

/* Reels */
var slideWrapper = $(".slickReels"),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;

const muteBtn = document.getElementById('muteBtn');

// 將 Click 事件移出 playPauseVideo，只綁定一次！
if (muteBtn) {
  muteBtn.addEventListener('click', function() {
    var currentSlide = slideWrapper.find(".slick-current");
    var video = currentSlide.children("video").get(0);
    
    if (video) {
      if (video.paused) {
        video.play();
        $('.reelsVoice').removeClass('muted');
      } else {
        video.pause();
        $('.reelsVoice').addClass('muted');
      }
    }
  });
}

// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, video;

  currentSlide = slick.find(".slick-current");
  video = currentSlide.children("video").get(0);
  slideType = currentSlide.attr("class").split(" ")[1];

  if (slideType === "video" && video != null) {
    if (control === "play"){
      video.play();
    } else {
      video.pause();
    }
  }
}

// DOM Ready
$(function() {
  if(slideWrapper.length){
    /* Initialize */
    slideWrapper.on("init", function(slick){
      slick = $(slick.currentTarget);
      playPauseVideo(slick,"play");
      $('.reelsVoice').removeClass('muted');
    });
    
    slideWrapper.on("beforeChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"pause");
      $('.reelsVoice').removeClass('muted');
    });
    
    slideWrapper.on("afterChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"play");
      $('.reelsVoice').removeClass('muted');
    });
    
    slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
      lazyCounter++;
      if (lazyCounter === lazyImages.length){
        lazyImages.addClass('show');
      }
    });
  
    slideWrapper.slick({
      slidesToShow: 3,
      infinite:true,
      lazyLoad:"progressive",
      cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
      arrows:true,
      responsive: [{
          breakpoint: 1235,
          settings: { slidesToShow: 3 }
        },{
          breakpoint: 1023,
          settings: { slidesToShow: 3 }
        },{
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            centerMode: true,
          }
        },{
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
          }
        }
      ]
    });
  }
});